module.exports = __webpack_public_path__ + "img/image01.4925ac91.jpg";